<template>
  <div class="status-search flex">
    <div class="status-dropdown"  v-click-outside="closeDropdown">
      <div class="status-dropdown__title flex align-center"  @click="toggleDropdown">
        <div class="status-dropdown__count-status flex flex-center align-center" v-if="statusOptionsCount">+{{statusOptionsCount}}</div>
        <span class="status-dropdown__text">{{$t('mc.supervisor.search.status')}}</span> 
        <img :class="[{'status-dropdown__arrow_active': openDropdown},'status-dropdown__arrow']" src="@/assets/svg/dropdown-arrow.svg">
      </div>
      <transition name="fade">
        <div class="status-dropdown__list" v-if="openDropdown">
          <!-- <input class="input set-mimk__input input-text"
            type="text"
            :placeholder="$t('mc.placeholders.search')"
            v-model="searchedStatus"
          /> -->
          <div class="status-dropdown__items">
            <div 
              :class="[{'status-dropdown__item_active': item.active === true},'status-dropdown__item']"
              v-for="(item, index) of findStatusesMimk" :key="index"
              @click="choiseItemForFilter(index)">
              <span>{{$t(item.translateStatusTitle)}}</span>
              <div class="status-dropdown__icon_check">
                <inline-svg
                  v-if="item.active"
                  :src="require(`@/assets/svg/check.svg`)"
                /> 
              </div>
            </div>
          </div>
          <div class="line" />
          <div v-if="chosenStatusFilter.length" class="status-dropdown__chosen-options" >
            <div class="status-dropdown__chosen-option"
              v-for="(chouseItem, index) of chosenStatusFilter"
              :key="index"
              @click="deleteChouseItem(chouseItem,index)">
              <span>{{$t(chouseItem.translateStatusTitle)}}</span>
                <inline-svg
                  :src="require(`@/assets/svg/close.svg`)"
                  class="status-dropdown__delete-icon"
                />  
            </div>
          </div>
          <div class="status-dropdown__button flex flex-center align-center">
            <button
              class="btn" 
              :disabled="!chosenStatusFilter.length"
              @click="sortTable"
              >{{$t('mc.supervisor.search.buttons.save')}}
              </button>
          </div>
        </div>
      </transition>
    </div>
    <button class="status-search__clear btn" @click="dropAllOptions(true)">
      {{$t('mc.supervisor.search.buttons.clear')}}
      <inline-svg
        :src="require(`@/assets/svg/close.svg`)"
        class="status-search__close"
      />  
    </button>
  </div>
</template>

<script>
import { statusesMimkForFilter } from '@/helpers/changeStatuses'
export default {
  data() {
    return {
      statusesMimk: statusesMimkForFilter,
      openDropdown: false,
      chosenStatusFilter: [],
      statusOptionsCount: null,
      searchedStatus: ''
    }
  },
  methods: {
    //Метом отправляющий эмит с выбранными статусами (this.chosenStatusFilter) МИМК для фильтра массива МИМКов
    sortTable() {
      this.$emit('sortTable', this.chosenStatusFilter)
      this.openDropdown = false
    },
    //Метод срабатываемый при сбрасывании всех опций для фильтра статуса МИМКов
    dropAllOptions(cleanInput) {
      this.findStatusesMimk.forEach(element => {
        element.active = false
      });
      if (cleanInput) this.searchedStatus = ''
      this.chosenStatusFilter = []
      this.statusOptionsCount = null
      this.$emit('dropAllOptions')
    },
    //Метод срабатываемый при удалении статуса из выбранного списка статусов, при нажатии на элемент из списка с выбранными статусами
    deleteChouseItem(item, index) {
      let indexOfChoseStatus = this.findStatusesMimk.findIndex(el => el.title === item.title)
      this.findStatusesMimk[indexOfChoseStatus].active = false
      this.chosenStatusFilter.splice(index, 1)
      this.statusOptionsCount--
      if (this.statusOptionsCount === 0) this.dropAllOptions()
    },
    toggleDropdown() {
      this.openDropdown = !this.openDropdown
    },
    closeDropdown() {
      this.openDropdown = false
    },
    //Метод выбора статусов МИМК
    choiseItemForFilter(itemIndex) {
      //Добавляем класс активности выбранным статусам в списке всех статусов
      this.findStatusesMimk[itemIndex].active = !this.findStatusesMimk[itemIndex].active
      //1.Делаем проверки если выбранного статуса не содержиться в массиве с выбранными статусами то добаляем статус в массив выбранных и увеличиваем каунтер
      if (!this.chosenStatusFilter.includes(this.findStatusesMimk[itemIndex].title) && this.findStatusesMimk[itemIndex].active) {
        this.chosenStatusFilter.push(this.findStatusesMimk[itemIndex])
        this.statusOptionsCount++
      }else {
        //Если содержиться, то уменьшаем каунтер и удаляем данный статус из массивы выбранных
        let indexOfChoseStatus = this.chosenStatusFilter.findIndex(el => el === this.findStatusesMimk[itemIndex])
        this.chosenStatusFilter.splice(indexOfChoseStatus, 1)
        this.statusOptionsCount--
      }
      //Если при выборе статуса каунт === 0 , значит пользователь удалил все статусы , поэтому чистим все опции
      if (this.statusOptionsCount === 0) this.dropAllOptions()
    },
  },
  computed: {
    //Компьютед со списком статусов МИМК который фильруется поисковой строкой в дропдауне
    findStatusesMimk() {
      let object = this.statusesMimk.filter((element) => {
        return (element.title.toLowerCase().trim().indexOf(this.searchedStatus.toLowerCase().trim()) != -1 )
      });
      return object;
    },
  }
}
</script>

<style lang="scss" scoped>
.set-mimk__input{ 
  width: 80%;
  margin-left: 30px;
}
.line {
  width: 100%;
  height: 1px;
  background: #C9C9C9;;
}
.status{
   &-search {
    &__clear {
      margin-left: 20px;
      background: #fff;
      max-width: 155px;
      min-width: 155px;
      font-size: 14px;
      height: 48px;
      color: #485270
    }
    &__close {
      margin-left: 20px;  
      min-width: 22px;
      min-height: 22px;
    }
  }
  &-dropdown {
  cursor: pointer;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 48px;
  padding: 0 16px;
  background: #fff;
  border: 1px solid #C9C9C9;
  border-radius: 4px;
  &__count-status {
    font-size: 12px;
    font-family: 'Open Sans', sans-serif;
    margin-right: 8px;
    color: #fff;
    background: #080C59;
    border-radius: 80px;
    width: 24px;
    height: 24px;
  }
  &__chosen-options {
    border-bottom: 1px solid #C9C9C9;
    padding: 13px 0 13px 20px;
  }
  &__chosen-option {
    color: #485270;
    display: inline-flex;
    padding: 5px 15px;
    align-items: center;
    background: #F6F6F8;
    border-radius: 80px;
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  &__items {
    // margin-top: 18px;
    margin-bottom: 15px;
  }
  &__item {
    padding: 7px 30px;
    display: grid;
    grid-template-columns: 1fr 13px;
    // white-space: nowrap;
    font-family: 'Open Sans', sans-serif;;
    opacity: 0.5;
    &:hover {
      background-color: #C9C9C9;
    }
    &_active {
      opacity: 1;
      color: #315AF2;
      background-color: #fff;
    &:hover {
      background-color: #fff;
    }
    }
  }
  &__icon_check {
    width: 100%;
    text-align: right;
    margin-right: 42px;
  }
  &__text {
    opacity: 0.5;
  }
  &__list {
    position: absolute;
    left: -5px;
    top: 40px;
    min-height: 100px;
    width: 295px;
    align-items: center;
    padding: 17px 0;
    background: #fff;
    border: 1px solid #C9C9C9;
    border-radius: 4px;
    z-index: 2;
  }
  &__arrow {
    margin-left: 16px;
    &_active {
      transform: rotate(180deg);
      transition:  .2s
    } 
  }
  &__delete-icon::v-deep {
    margin-left: 10px;
    width: 9px;
    height: 9px;
    & path {
      fill: #485270;;
    }
  }
  &__button {
    margin-top: 14px;
  }
  }
}
</style>